import { paths, storeConnectionResponseSchema } from "@go-novus/admin-api";

import type { Tenant } from "#/entities/tenant";
import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/** 这个 feature 的语义读操作名，失败会带上它，UI 据此挑文案。 */
export const getStoreConnectionOperation = "store_connection.read";

export type GetStoreConnectionOperation = typeof getStoreConnectionOperation;

export type GetStoreConnectionFailure =
  BackendFailure<GetStoreConnectionOperation>;

export function getStoreConnection(
  options: { fetch?: typeof globalThis.fetch; signal?: AbortSignal } = {},
): ResultAsync<Tenant, GetStoreConnectionFailure> {
  return requestBackendResult({
    fetch: options.fetch,
    method: "GET",
    operation: getStoreConnectionOperation,
    parse: (payload) => storeConnectionResponseSchema.parse(payload),
    path: paths.storeConnection,
    signal: options.signal,
  });
}
